













































import Vue from 'vue';
import Icon from '../Icon';

export default Vue.extend({
  components: { Icon },
  props: {
    accept: { type: String, default: null },
    done: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    fileName: { type: String, default: '' },
    label: { type: String, required: true },
    maxFileSize: { type: Number, default: 0 },
    borderWidth: { type: Number, default: 1 },
  },
  data() {
    return {
      file: {} as File,
      icon: this.done ? 'delete' : 'upload',
      isDone: this.done,
      progress: 0,
      progressInterval: null as any,
    };
  },
  watch: {
    done(value) {
      this.isDone = value;
    },
  },
  computed: {
    hideUpperTitle(): boolean {
      return this.isDone || !this.fileName;
    },
    isLoading(): boolean {
      return ['', 'check'].includes(this.icon);
    },
    title(): string {
      return this.fileName || this.label;
    },
  },
  methods: {
    actionIconHandler(event: Event) {
      if (this.icon === 'delete') {
        event.preventDefault();
        this.icon = 'upload';
        (this.$refs.inputFile as HTMLInputElement).value = '';
        this.$emit('delete');
      }
    },
    changeHandler(event: Event) {
      const file = (event.target as any).files[0];

      if (!file) return;

      if (this.accept && (!file.type || !this.accept.includes(file.type))) {
        this.$emit('error', 'type', file.type);
        return;
      }

      if (this.maxFileSize && file.size > this.maxFileSize) {
        this.$emit('error', 'size', file.size);
        return;
      }

      this.icon = '';
      this.progress = 0;

      this.progressInterval = setInterval(
        () => this.progressIntervalCallback(),
        200,
      );

      this.$emit('change', file);
    },
    progressIntervalCallback() {
      if (this.isDone) {
        clearInterval(this.progressInterval);

        this.progress = 100;

        this.icon = 'check';
        setTimeout(() => (this.icon = 'delete'), 500);
      } else if (this.progress < 90) {
        this.progress += 10;
      }
    },
  },
});
